import api from '../api'

import {
    CHANGE_PROGRESS,
    DELETE_CLIENT_SERVICE,
    UPDATE_CLIENT_SERVICE,
    UPDATE_CLIENT_SERVICES
} from '../mutations/available'

import _ from 'lodash'
import {extractCommonBackendError} from '../../../../helpers/api'
import NotificationService from '../../../../services/notificationService'

export const fetchClientServicesIfNeeded = async ({state, dispatch, commit}, clientId) => {
    if (!clientId) {
        return
    }

    let clientServices = _.get(state.clientServicesByClientId, clientId, null)

    if (clientServices !== null) {
        return clientServices
    }

    dispatch('fetchClientServices', clientId)
}

export const fetchClientServices = async ({state, dispatch, commit}, clientId) => {
    if (state.progress.getClientServicesByClientId) {
        return
    }

    commit(CHANGE_PROGRESS, {context: 'getClientServicesByClientId', value: true})

    try {
        const clientServices = await api.getClientServices(clientId)

        commit(UPDATE_CLIENT_SERVICES, {clientId, clientServices})
    } catch (e) {
        NotificationService.error(`Unable to get client services. Try again later`)
    }

    commit(CHANGE_PROGRESS, {context: 'getClientServicesByClientId', value: false})
}

export const addServiceToClient = async ({state, dispatch, commit}, {clientId, serviceId, price}) => {
    if (state.progress.addServiceToClient) {
        return
    }

    commit(CHANGE_PROGRESS, {context: 'addServiceToClient', value: true})

    const preparedPrice = parseFloat(price)

    let opResult = false

    try {
        await api.addServiceToClient({
            clientId,
            serviceId,
            price: preparedPrice
        })

        dispatch('fetchClientServices', clientId)

        opResult = true
    } catch (e) {
        NotificationService.error(extractCommonBackendError(e, `Unable to add service to client. Try again later`))
    }

    commit(CHANGE_PROGRESS, {context: 'addServiceToClient', value: false})

    return opResult
}

export const updateClientService = async ({state, dispatch, commit}, {id, price}) => {
    if (_.get(state.progress.updateClientService, id, false)) {
        return
    }

    commit(CHANGE_PROGRESS, {context: ['updateClientService', id], value: true})

    const preparedPrice = parseFloat(price)

    let opResult = false

    try {
        const updatedClientService = await api.updateClientService({
            id,
            price: preparedPrice
        })

        commit(UPDATE_CLIENT_SERVICE, updatedClientService)
        //dispatch('fetchClientServices', clientId)
        opResult = true
    } catch (e) {
        console.log(e.message)
        NotificationService.error(extractCommonBackendError(e, `Unable to update client service. Try again later`))
    }

    commit(CHANGE_PROGRESS, {context: ['updateClientService', id], value: false})

    return opResult
}

export const deleteClientService = async ({state, dispatch, commit}, clientService) => {
    if (_.get(state.progress.deleteClientService, clientService.id, false)) {
        return
    }

    commit(CHANGE_PROGRESS, {context: ['deleteClientService', clientService.id], value: true})

    let opResult = false

    try {
        await api.deleteClientService(clientService.id)

        commit(DELETE_CLIENT_SERVICE, {clientId: clientService.clientId, serviceId: clientService.serviceId})
        opResult = true
    } catch (e) {
        console.log(e)
        NotificationService.error(extractCommonBackendError(e, `Unable to delete client service. Try again later`))
    }

    commit(CHANGE_PROGRESS, {context: ['deleteClientService', clientService.id], value: false})

    return opResult
}

